<template>
    <div class="com-record-item dsp-flex" @click="clickRecordItem"  v-bind:class="{'colume-item-gray': parseInt(settingConfigData.showColor) == 0}">
        <div class="com-record-basic">
            <p><span class="com-record-name">{{source.name.slice(0, 10)}}</span><span class="com-record-status" v-bind:class="'com-record-status-' + source.status" v-if="source.type == 'my'">{{source.statusStr}}</span></p>
            <p class="com-record-info">
                <span>{{source.sex}}</span><span>{{source.dateStr}}</span><!--<span>03:03</span>-->
            </p>
            <p v-if="source.type == 'hot'" class="com-record-sub">
                <span class="com-record-sub-note">访问:{{source.pvNum}}</span>
                <span class="com-record-sub-note">评论:{{source.replyNum}}</span>
            </p>
            <p v-if="source.type != 'hot' && source.creator" class="com-record-sub">
                <span class="com-record-sub-note">创建人:{{source.creator}}</span>
            </p>
        </div>
        <div class="com-record-detail">
            <div class="dsp-flex" v-bind:class="{'direct-rtl': parseInt(settingConfigData.nianyueRishi) == 1}">
                <div class="com-record-word" v-for="(wordValue, index) in source.eightWordArr" v-bind:key="wordValue + index">
                    <p v-bind:class="'wd-' + wordValue[0].propXingEn">{{wordValue[0].text}}</p>
                    <p v-bind:class="'wd-' + wordValue[1].propXingEn">{{wordValue[1].text}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { CONST_FAMOUS_PEDIA_EDIT_TYPE } from '../../modules/data/base/consts';
import { LOADING_DOM } from '../../modules/dom';
export default {
    name: 'FamousRecordItem',
    props: {
        source: {
            type: Object,
            default() { return {} }
        }
    },
    computed: {
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        }
    },
    data() {
        return {
            locked: false
        }
    },
    methods:{
        clickRecordItem() {
            var me = this, data = this.source;
            if(this.locked) { return; }
            this.locked = true;
            setTimeout(() => {
                me.locked = false;
            }, 2000);
            LOADING_DOM.showLoading();
            this.$store.dispatch('comment/resetData');
            this.$store.dispatch('minifatefortune/resetMiniData');
            this.$store.dispatch('famouspediacomment/resetData');
            this.$store.dispatch('famouspedia/resetPediaData');
            this.$store.dispatch('famouspedia/initBaikeInfo', {
                fromDetail: false,
                baikeId: data.id,
                baikeType: data.type,
                baikeStatus: data.status,
                sucCb: function(curEditType) {
                    me.locked = false;
                    if(curEditType == CONST_FAMOUS_PEDIA_EDIT_TYPE.read) {
                        me.$router.replace('/famouspediaread/' + data.id + '/famouspedia')
                    }else {
                        me.$router.replace('/famouspediaedit')
                    }
                    LOADING_DOM.hideLoading();
                },
                failCb: function() {
                    me.locked = false;
                    me.$toast('没有找到这个八字的百科数据');
                    LOADING_DOM.hideLoading();
                }
            })
        }
    }
}
</script>